import {makeStyles} from '@material-ui/core';
import {CremaTheme} from '../../../../types/AppContextPropsType';

const useStyles = makeStyles((theme: CremaTheme) => ({
  tableCell: {
    fontSize: 13,
    padding: 11,
    whiteSpace: 'nowrap',
    '&:first-child': {
      paddingLeft: 20,
    },
    '&:last-child': {
      paddingRight: 20,
    },
    [theme.breakpoints.down('sm')]: {
      '&:first-child': {
        paddingLeft: 10,
      },
      '&:last-child': {
        paddingRight: 10,
      },
    },
  },
  whiteSpace: {
    whiteSpace: 'nowrap',
  },
  anchar: {
    color: theme.palette.primary.main,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    display: 'inline-block',
  },
  badgeRoot: {
    padding: '3px 5px',
    borderRadius: 4,
    fontSize: 14,
    display: 'inline-block',
  },
  boxDisplay: {
    display: '',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('xs')]: {
      width: '30px',
    },
  },
  countDisplay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 80,
    height: 40,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      width: 80,
    },
    [theme.breakpoints.down('xs')]: {
      width: 50,
      height: 30,
      fontSize: 12,
    },
  },
  padding: {
    padding: 12,
    [theme.breakpoints.down('md')]: {
      padding: 6,
    }, 
  },

}));
export default useStyles;
